import { Table } from "antd";
import { TableContainer } from "./styled";
import { useContext } from "react";
import { ContextProviderWrapper } from "../../Context";
import { useDispatch } from "../../../store/store";
import { getPoolDetail } from "../../../store/features/poolsSlice";

const { Column } = Table;

const TableCommon = ({
  data,
  heading,
  pagination = true,
  callback,
  className,
}: any) => {
  const { theme } = useContext(ContextProviderWrapper)!;
  const dispatch = useDispatch();
  return (
    <TableContainer className={`${theme} ${className}`}>
      <Table
        dataSource={data}
        pagination={pagination}
        onRow={(record) => {
          return {
            onClick: () => {
              if (callback) {
                callback(record);
              }
            },
          };
        }}
      >
        {heading.map((item: any) => {
          return (
            <Column
              title={item.name}
              dataIndex={item.dataIndex}
              key={item.key}
              render={item.render}
            />
          );
        })}
      </Table>
    </TableContainer>
  );
};

export default TableCommon;
